import React, { useContext } from 'react'
import sanitize from 'sanitize-html'

import { Button } from 'core-components/library/button'
import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { APLHeader } from '../../commonComponents/aplHeader/APLHeader'

import styles from './APLWelcomeContentHeader.module.scss'

interface IAPLWelcomeContentHeaderProps {
  redirectToPartnerRegistration: () => void
  proceedToAuth: () => void
}

export const APLWelcomeContentHeader = ({
  redirectToPartnerRegistration,
  proceedToAuth,
}: IAPLWelcomeContentHeaderProps) => {
  const { t } = useContext(LanguageContext)

  return (
    <APLHeader
      firstSlice={
        <p className={styles.firstSliceText}>{t(APLTranslationCodes.guest_header_title)}</p>
      }
      secondSlice={
        <>
          <div
            className={styles.secondSliceText}
            dangerouslySetInnerHTML={{
              __html: sanitize(t(APLTranslationCodes.guest_header_sub_title)),
            }}
          />
          <div className={styles.registrationControls}>
            <div>
              <Button
                className={styles.registrationControls__btn}
                onClick={redirectToPartnerRegistration}
              >
                {t(APLTranslationCodes.guest_registration_btn)}
              </Button>
            </div>
            <div>
              <Button className={styles.registrationControls__btn} onClick={proceedToAuth}>
                {t(APLTranslationCodes.guest_auth_btn)}
              </Button>
            </div>
          </div>
        </>
      }
    />
  )
}
